export const RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_GET = "/RavenAuthorizationResponseCodeDef/GetAllRavenAuthorizationResponseCodeDef"